import React from 'react'
import useStore from '../modules/useStore'

export default function AboutMe(props) {
    const { showProjects } = useStore(({showProjects}) => ({showProjects}))
    return (
        <div class="fixed overflow-y-scroll top-0 left-0 w-full h-full text-white px-4 md:px-10">
            <header class="flex items-center fixed top-0 left-0 px-4 md:px-10 py-14 h-0">
                <h1 className="text-base md:text-2xl pr-12">Hakim Mazouz</h1>
                <h2 className="text-base md:text-2xl opacity-50">Creative Technologist</h2>
            </header>
            <main class="md:flex pt-48 h-full">
                <div className="left md:w-3/4 md:pr-32 lg:pr-64 xl:pr-96 mb-24">
                    <p className="text-xl md:text-2xl mb-8">Developer and designer with a focus on motion and fluid interfaces since 2015.</p>
                    <p className="text-xl md:text-2xl mb-8">Collaborated with clients like Danish Broadcasting Corporation, YEEZY, LEGO and Porsche.</p>
                    <button className="px-8 py-2 mr-4 rounded-xl border-2 bg-white text-black font-medium hover:opacity-50 transition duration-500" onClick={showProjects}>View work</button>
                    <a className="px-8 py-2 inline-block border-2 rounded-xl bg-transparent text-white font-medium hover:opacity-50 transition duration-500" href="mailto:hakim@micromono.studio">Let's talk</a>
                </div>
                <div className="right md:w-1/4 flex flex-col justify-end h-full pb-8">
                    <h3 className="mb-8">Work history</h3>
                    <ul className="p-0 m-0 w-full">
                        <li className="flex mb-4 justify-between w-full"><span>Kontrapunkt</span><span className="opacity-50">2021 - Present</span></li>
                        <li className="flex mb-4 justify-between w-full"><span>Dwarf</span><span className="opacity-50">2017 - 2021</span></li>
                        <li className="flex mb-4 justify-between w-full"><span>Plant</span><span className="opacity-50">2016 - 2017</span></li>
                        <li className="flex mb-4 justify-between w-full"><span>Freelance</span><span className="opacity-50">2015 - Present</span></li>
                    </ul>
                </div>
            </main>
        </div>
    )
}